define('components/util/clearbutton',[
    'jquery'
],function($){
    var _this = this;


    /**
     * remove the clear button
     */
    function removeButton(input){
      var sibling = input.next().first();
      if(sibling.hasClass("clearbutton")){
        sibling.remove();
      }
    }

    //check if the clear button already exists for this input field
    function checkButtonExists(input){
      var sibling = input.next().first();
      if(sibling.hasClass("clearbutton")){
        return true;
      }
      return false;
    }

    /**
     * create the clear button
     */
    function createButton(input){
      var offset = input.position();
      var left = offset.left + input.outerWidth() - 20;
      var top = offset.top + (input.outerHeight()/2);

      // CI-7336 disallow tab to clear button to optimize user tab flow (good solution?)
      var button = $('<a href="javascript:void(0);" class="clearbutton" style="left:'+left+'px; top:'+top+'px;" tabindex="-1"><span class="ico ico-times-circle"></span></a>');
      button.on("click", function(){
        input.val("");
        if (!input.context.getAttribute('noreload') || input.context.getAttribute('noreload') != 'true') {
            input.change();
        }
        removeButton(input);
        input.focus();
      });

      input.after(button);
      checkButtonExists(input);
    }

    function keyUp(e){
      var input = $(e.target);
      //check if the clear button already exists
      if(input.val().length >0 && !checkButtonExists(input)){
        createButton(input);
      }else if(input.val().length === 0){
        removeButton(input);
      }
    }

    /**
     * all the free input fields in the filter form,
     * should get clear input button
     * @param {element} f form
     */
    function setClearInputFieldsIcons(f){
      var inputs = $(f).find('input[data-clearbutton]');

      if(inputs.length === 0){return;}

      inputs.each(function(){
        var input = $(this);
        if(input.val().length >0 && !checkButtonExists(input)){
          createButton(input);
        }
        input.keyup(keyUp);
      });

    }

    return {
      setClearInputFieldsIcons: setClearInputFieldsIcons
    };

});

